const formSchema = [
  {
    type: 'inputpassword',
    name: 'password',
    label: '旧密码',
    isRequired: true,
    extra: '',
    antdProps: {
      placeholder: '请输入旧密码',
    },
  },
  {
    type: 'inputpassword',
    name: 'new_password',
    prefix: 'brand',
    placeholder: '请输入6-20位字母+数字组合的新密码',
    label: '新密码',
    isRequired: true,
  },
  {
    type: 'inputpassword',
    name: 'new_password_confirm',
    label: '确认密码',
    isRequired: true,
    placeholder: '再次确认输入新密码',

  },
];

export default formSchema;